module.exports = __webpack_public_path__ + "img/Insurance.052b1ffc.svg";